import React from "react";
import "./SkillBubbleChart.css";

const truncateSkillName = (name, index) => {
  if (typeof name !== "string") return "";
  return name.length > 15 && index > 4 ? `${name.substr(0, 15)}...` : name;
};

const SkillBubbleChart = ({ data = [] }) => (
  <div className="skillChart">
    {data?.map((element, index) => {
      const skillName = element?.SkillName || element?.name || "Skill";
      const percentage = element?.Percentage ?? element?.value ?? "";

      return (
        <div
          key={`${skillName}-${index}`}
          className={`skill-${index}`}
          title={`${skillName} \n ${percentage}`}
        >
          <div className="name">
            <p>{truncateSkillName(skillName, index)}</p>
            <div>{percentage}</div>
          </div>
        </div>
      );
    })}
  </div>
);

export default SkillBubbleChart;
